import React from "react";
import PropTypes from "prop-types";
import advantageMocks from "../../../mocks/advantages";
import Grid from "@material-ui/core/Grid";
import Advantage from "./Advantage";
import withErrorBoundary from "../../../decorators/withErrorBoundary";

function Advantages(props) {
  const {
    productName,
    condition: {options}
  } = props;

  const material = options && options.material;

  let advantages;

  if (advantageMocks[productName]) {
    advantages =
      advantageMocks[productName][material] || advantageMocks[productName];
  } else {
    advantages = advantageMocks.default;
  }

  return (
    <Grid container>
      {advantages.map(({icon, text}) => (
        <Grid key={icon} item xs={4}>
          <Advantage icon={icon} text={text} />
        </Grid>
      ))}
    </Grid>
  );
}

Advantages.propTypes = {
  productName: PropTypes.string,
  condition: PropTypes.object
};

export default withErrorBoundary(Advantages);
